import * as styles from '@core/components/ImageViewer/ImageViewer.css';

export interface InteractiveImageContainerProps {
  canInteract: boolean;
  isBlurred: boolean;
  onToggleBlur?: () => void;
  children: React.ReactNode;
}

/**
 * Interactive image container that handles blur toggle using a semantic button
 */
export function InteractiveImageContainer({ canInteract, isBlurred, onToggleBlur, children }: InteractiveImageContainerProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (canInteract && onToggleBlur) {
      onToggleBlur();
    }
  };

  const containerTitle = canInteract ? (isBlurred ? 'Click to show content' : 'Click to hide content') : undefined;

  if (canInteract) {
    return (
      <button
        aria-label={isBlurred ? 'Show blurred content' : 'Hide sensitive content'}
        className={styles.interactiveButton}
        title={containerTitle}
        type="button"
        onClick={handleClick}
      >
        {children}
      </button>
    );
  }

  return <div className={styles.imageContainer}>{children}</div>;
}
